import { Components } from '@mui/material';
import { Theme } from '@mui/system';

export const buildMuiRadioComponent = (): Components<Omit<Theme, 'components'>>['MuiRadio'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      '> span': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        '.MuiSvgIcon-root': {
          // Unchecked icon
          '&:nth-of-type(1)': {
            border: `1px solid ${theme.palette.secondary.main}`,
            borderRadius: '24px',
            fontSize: '24px',
            fill: 'transparent',
          },
          // Checked icon
          '&:nth-of-type(2)': {
            fill: 'transparent',
            background: theme.palette.secondary.main,
            fontSize: '16px',
            borderRadius: '16px',
            left: '0',
            right: '0',
            margin: '0 auto',
            top: 'calc(50% - 8px)',
          },
          '&.MuiSvgIcon-fontSizeSmall': {
            // Unchecked icon
            '&:nth-of-type(1)': {
              borderRadius: '15px',
              fontSize: '15px',
            },
            // Checked icon
            '&:nth-of-type(2)': {
              fontSize: '9px',
              borderRadius: '9px',
              top: 'calc(50% - 4.5px)',
            },
          },
        },
      },
      ':not(.Mui-checked)': {
        '> span': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          '.MuiSvgIcon-root': {
            // Unchecked icon
            '&:nth-of-type(1)': {
              border: `1px solid ${theme.palette.primary[50]}`,
            },
          },
        },
      },
      '&.Mui-disabled': {
        '> span': {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          background: theme.palette.primary[30],
          cursor: '',
          borderRadius: '50%',

          '.MuiSvgIcon-root': {
            // Unchecked icon
            '&:nth-of-type(1)': {
              border: `1px solid ${theme.palette.primary[50]}`,
              background: 'transparent',
            },
            // Checked icon
            '&:nth-of-type(2)': {
              background: theme.palette.primary[50],
            },
          },
        },
      },
    }),
    sizeSmall: {
      padding: '7px',
    },
  },
});
